<template>
  <a-modal
    v-model="visible"
    :style="{ display: !modalShow ? 'none' : '' }"
    :title="null"
    :footer="null"
    :closable="false"
    :width="320"
    :maskClosable="false"
    wrapClassName="all-modal"
    dialogClass="dialogClass"
    :bodyStyle="{ 'border-radius': '16px', background: '#fff' }"
    @cancel="visible = false"
  >
    <div class="InspectResult">
      <div class="header center">
        {{ stringList.CompleteInspection }}
        <div class="close">
          <svg-icon
            iconClass="close-x"
            style="width: 14px; height: 14px"
            @click="handleOk"
          ></svg-icon>
        </div>
      </div>

      <div class="InspectResult-con">
        <div class="roomNumber center">
          {{ stringList.room }}: {{ resultData.roomNumber }}
        </div>
        <div class="score">
          <span>{{ stringList.SCORE }}</span>
          <span>{{ resultData.score }}</span>
        </div>
        <div class="time center">
          {{ stringList.CompletedIn }}&nbsp;
          <span>{{ resultData.checkTotalMinutes }}</span>
          &nbsp;{{ stringList.minutes }}
        </div>
        <div class="report center" v-if="failItemParamList.length">
          {{ stringList.ItemsReported }} ({{ resultData.failNum }})
        </div>

        <div class="list">
          <div
            class="item"
            v-for="(item, index) in failItemParamList"
            :key="index"
          >
            <div class="point"></div>
            <div class="content">
              {{ item.areaNameLanguage }}: {{ item.itemNameLanguage }}
            </div>
          </div>
        </div>

        <div class="report center" style="margin-top: 14px">
          {{ stringList.HotelInspectionSToday }}: {{ resultData.checkNum }}
        </div>

        <div class="footer center">
          <van-button
            :spinning="true"
            class="button"
            @click="handleOk"
            native-type="submit"
            >{{ stringList.OK }}</van-button
          >
        </div>
      </div>
    </div>
  </a-modal>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      visible: false,
      modalShow: false,
      resultData: {
        failItemList: [],
      },
      failItemParamList: [],
    };
  },
  computed: {
    ...mapGetters({
      stringList: "stringList",
    }),
  },
  created() {},
  methods: {
    init(data) {
      this.modalShow = true;
      this.visible = true;

      let { resultData, failItemParamList } = data;
      this.resultData = resultData;
      this.failItemParamList = failItemParamList;
    },
    handleOk() {
      this.modalShow = false;
      this.visible = false;
      this.$router.replace("/home");
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/.dialogClass {
  .ant-modal-body {
    padding: 0 !important;
    overflow: hidden !important;
  }
}
.InspectResult {
  flex: 1;
  background-color: #ffffff;
  overflow-y: auto;

  &-con {
    padding: 0 24px 40px;
  }
}

.header {
  width: 100%;
  height: 55px;
  background: #f2f2f2;

  font-size: 20px;
  font-weight: bold;
  color: #5a578c;

  position: relative;

  .close {
    position: absolute;
    right: 20px;
    top: 50%;
    transform: translateY(-50%);
  }
}

.roomNumber {
  font-size: 18px;
  font-weight: bold;
  line-height: 20px;
  color: #000000;
  margin-top: 30px;
}

.score {
  margin: 20px auto 0;
  width: 92px;
  height: 92px;
  border-radius: 100px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0px 0px 20px 0px;
  border: 2px solid #f2f2f2;

  span:first-of-type {
    font-size: 12px;
    font-weight: bold;
    line-height: 20px;
    color: #5f5f5f;
  }
  span:nth-child(2) {
    font-size: 36px;
    font-weight: bold;
    line-height: 20px;
    color: #5a578c;
    margin-top: 10px;
  }
}

.time {
  font-size: 14px;
  line-height: 20px;
  color: #3d3d3d;
  margin-top: 20px;

  span {
    font-size: 16px;
    font-weight: bold;
    line-height: 20px;
    color: #5f5f5f;
  }
}

.report {
  font-size: 16px;
  font-weight: bold;
  line-height: 22px;
  color: #101010;
  margin-top: 20px;
}
.list {
  width: 74%;
  max-height: 200px;
  overflow-y: auto;
  margin: 12px auto 0;

  .item {
    padding-left: 10px;
    position: relative;
    margin-bottom: 6px;
    .point {
      position: absolute;
      top: 5px;
      left: 0;
      width: 4px;
      height: 4px;
      border-radius: 50%;
      background: #101010;
    }
    .content {
      margin-left: 8px;
      font-family: Arial;
      font-weight: 400;
      font-size: 15px;
      text-align: left;
    }
  }
}

.footer {
  margin: 24px auto 0;
  .button {
    width: 140px;
    height: 48px;
    border-radius: 8px;
    opacity: 1;
    background: #ff6600;
    font-family: Arial;
    font-size: 16px;
    font-weight: 700;
    line-height: 18.72px;
    text-align: center;
    // display: flex;
    // align-items: center;
    letter-spacing: 0em;
    color: #ffffff;
    border: 0;
  }
}
</style>
